import angular from 'angular'
import ngFileUpload from 'ng-file-upload'

import api from 'components/api'
import fileMedia from 'common/file-media.service'
import jumbotronDialog from 'common/jumbotron-dialog.directive'

import AssetUploadService from './asset-upload.service'
import assetUploadDropZone from './asset-upload-drop-zone.component'
import assetUploadConflictModal from './asset-upload-conflict-modal.component'

export default angular.module('jumbotron.asset-upload', [
  ngFileUpload,
  api,
  fileMedia,
  jumbotronDialog
])
  .service('AssetUploadService', AssetUploadService)
  .component('assetUploadDropZone', assetUploadDropZone)
  .component('assetUploadConflictModal', assetUploadConflictModal)
  .name
